module.exports = __webpack_public_path__ + "OpenSans-ExtraBold-5211065d7cf88c28086d8f99f8705b71.woff2";